/* eslint-disable @typescript-eslint/no-misused-promises */
import React, { useContext, useState } from 'react'
import View from '../../atoms/View'
import Text from '../../atoms/TextNew'
import { t } from 'i18next'
import { minBetRise } from '../../../consts/other'

import Button from '../../atoms/Button'
import PriceInput from 'src/components/atoms/PriceInput'
import { ItemDispatchContext } from 'src/contexts/itemContext'
import { createBet } from 'src/helpers/api/createBet'
import { useDispatch } from 'react-redux'
import { CREATE_BET_SUCCESS, OPEN_DEMO_MODAL } from 'dealer-reducers'
import useDealerAllowedToPlaceOffer from 'src/hooks/useDealerAllowedToPlaceOffer'
interface Props {
  highestBet: number
  offerId: number
}

const AuctionContractBar = ({ offerId, highestBet }: Props): JSX.Element => {
  const dealerAllowedToPlaceOffer = useDealerAllowedToPlaceOffer()
  const dispatch = useDispatch()
  const dispatchItemContext = useContext(ItemDispatchContext)
  if (dispatchItemContext === null) {
    throw new Error('itemContext must be used within a UserProvider')
  }

  const [value, setValue] = useState(0)

  return (
    <View
      onClick={(e) => {
        e.stopPropagation()
      }}
      className="h-[104px] px-6 flex justify-between cursor-auto shadow-bothMedium rounded-b-4 bg-gradient-to-b from-blueGradientStart to-blueGradientStop">
      <View className="w-[300px] flex justify-center items-center text-center">
        <Text className="text-xl text-white font-SemiBold">
          <>{t('buy_now_modal.title')}</>
        </Text>
      </View>
      <View className="min-w-[200px] max-w-[250px] flex justify-center items-center text-center">
        <PriceInput value={value} minimalPrice={highestBet + minBetRise} onSetValue={setValue} />
      </View>
      <View className="flex flex-col justify-center gap-2">
        <View className="flex gap-2 justify-around items-center">
          <Button
            color="transparent"
            variant="medium"
            onClick={() => {
              dispatchItemContext({ type: 'TOGGLE_VIEW' })
              dispatchItemContext({ type: 'RESET_BAR' })
            }}>
            <Text className="text-xl text-white font-SemiBold">
              <>{t('auction_contract_modal.resign')}</>
            </Text>
          </Button>
          <Button
            dataTestId="create-bet-button"
            color="yellow"
            variant="medium"
            disabled={!dealerAllowedToPlaceOffer}
            customStyles="!rounded-[10px] !min-w-[144px]"
            onClick={async () => {
              try {
                if (!dealerAllowedToPlaceOffer) {
                  dispatch(OPEN_DEMO_MODAL())
                  return
                }
                const payload = await createBet({ offerId, betValue: value })
                dispatchItemContext({ type: 'CREATE_BET_SUCCESS', payload })
                dispatch(CREATE_BET_SUCCESS({ offer: payload, bar: 'thank_you_auction_contract' }))
              } catch (error) {
                dispatchItemContext({ type: 'CREATE_BET_FAILURE' })
              }
            }}>
            <Text className="text-xl  text-white font-SemiBold">
              <>{t('auction_contract_modal.place_offer')}</>
            </Text>
          </Button>
        </View>
        <View
          className="flex gap-1 justify-center text-white text-m"
          dangerouslySetInnerHTML={{ __html: t('auction_contract_modal.term') }}
        />
      </View>
    </View>
  )
}

export default AuctionContractBar
